(function () {
    'use strict';

    /* ============================================
       THEME SYSTEM
       ============================================ */
    var THEME_KEY = 'theme';
    var DARK = 'dark';
    var LIGHT = 'light';

    function getStoredTheme() {
        try { return localStorage.getItem(THEME_KEY) || DARK; }
        catch (e) { return DARK; }
    }

    function applyTheme(theme) {
        var root = document.documentElement;
        var isDark = theme !== LIGHT;
        root.setAttribute('data-theme', isDark ? DARK : LIGHT);
        try { localStorage.setItem(THEME_KEY, isDark ? DARK : LIGHT); } catch (e) {}

        var meta = document.querySelector('meta[name="theme-color"]');
        if (meta) meta.content = isDark ? '#070a0f' : '#f3f5ef';

        // Update canvas particles if they exist
        if (window.__particleSystem) {
            window.__particleSystem.updateColors();
        }
    }

    // Apply immediately (FOUC prevention — also done in inline script)
    (function () {
        var t = getStoredTheme();
        document.documentElement.setAttribute('data-theme', t === LIGHT ? LIGHT : DARK);
    })();

    /* ============================================
       DOM CONTENT LOADED
       ============================================ */
    document.addEventListener('DOMContentLoaded', function () {

        // Apply theme fully (icons, meta, etc.)
        applyTheme(getStoredTheme());

        // Theme toggle button
        var themeBtn = document.getElementById('themeToggle');
        if (themeBtn) {
            themeBtn.addEventListener('click', function () {
                applyTheme(getStoredTheme() === DARK ? LIGHT : DARK);
            });
        }

        /* Preloader is handled by inline script in HTML */

        /* ============================================
           PARTICLE CANVAS (Hero)
           ============================================ */
        (function () {
            var canvas = document.getElementById('heroCanvas');
            if (!canvas) return;
            if (window.matchMedia('(max-width: 768px)').matches ||
                window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                canvas.hidden = true;
                return;
            }

            var ctx = canvas.getContext('2d');
            var particles = [];
            var maxParticles = 80;
            var connectionDistance = 120;
            var animId;

            function getAccentRGB() {
                var style = getComputedStyle(document.documentElement);
                var rgb = (style.getPropertyValue('--c-ar') || style.getPropertyValue('--accent-color-rgb') || '').trim();
                if (!rgb) return [100, 255, 218];
                return rgb.split(',').map(function (v) { return parseInt(v.trim(), 10); });
            }

            var accentRGB = getAccentRGB();

            function resize() {
                canvas.width = canvas.offsetWidth;
                canvas.height = canvas.offsetHeight;
                maxParticles = Math.min(80, Math.floor((canvas.width * canvas.height) / 15000));
            }

            function createParticle() {
                return {
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    vx: (Math.random() - 0.5) * 0.4,
                    vy: (Math.random() - 0.5) * 0.4,
                    r: Math.random() * 2 + 1,
                    alpha: Math.random() * 0.5 + 0.2
                };
            }

            function init() {
                particles = [];
                for (var i = 0; i < maxParticles; i++) {
                    particles.push(createParticle());
                }
            }

            function draw() {
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                // Draw connections
                for (var i = 0; i < particles.length; i++) {
                    for (var j = i + 1; j < particles.length; j++) {
                        var dx = particles[i].x - particles[j].x;
                        var dy = particles[i].y - particles[j].y;
                        var dist = Math.sqrt(dx * dx + dy * dy);
                        if (dist < connectionDistance) {
                            var alpha = (1 - dist / connectionDistance) * 0.15;
                            ctx.strokeStyle = 'rgba(' + accentRGB[0] + ',' + accentRGB[1] + ',' + accentRGB[2] + ',' + alpha + ')';
                            ctx.lineWidth = 0.5;
                            ctx.beginPath();
                            ctx.moveTo(particles[i].x, particles[i].y);
                            ctx.lineTo(particles[j].x, particles[j].y);
                            ctx.stroke();
                        }
                    }
                }

                // Draw particles
                for (var k = 0; k < particles.length; k++) {
                    var p = particles[k];
                    ctx.beginPath();
                    ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
                    ctx.fillStyle = 'rgba(' + accentRGB[0] + ',' + accentRGB[1] + ',' + accentRGB[2] + ',' + p.alpha + ')';
                    ctx.fill();
                }
            }

            function update() {
                for (var i = 0; i < particles.length; i++) {
                    var p = particles[i];
                    p.x += p.vx;
                    p.y += p.vy;

                    if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
                    if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
                }
            }

            function animate() {
                update();
                draw();
                animId = requestAnimationFrame(animate);
            }

            window.__particleSystem = {
                updateColors: function () {
                    accentRGB = getAccentRGB();
                }
            };

            var resizeTimeout;
            window.addEventListener('resize', function () {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function () {
                    resize();
                    init();
                }, 200);
            }, { passive: true });

            resize();
            init();
            animate();

            // Pause when not visible
            document.addEventListener('visibilitychange', function () {
                if (document.hidden) {
                    cancelAnimationFrame(animId);
                } else {
                    animate();
                }
            });
        })();

        /* ============================================
           TYPING ANIMATION
           ============================================ */
        (function () {
            var el = document.getElementById('typingText');
            if (!el) return;

            var titles = (window.SITE_TYPING_TITLES && window.SITE_TYPING_TITLES.length)
                ? window.SITE_TYPING_TITLES
                : [
                    'Senior Infrastructure & Security Engineer',
                    'Automation Architect (n8n & API)',
                    'VMware & Cloud Specialist',
                    'Cyber Security Expert',
                    'Building the future at Petlas'
                ];

            var titleIndex = 0;
            var charIndex = titles[0].length;
            var isDeleting = true;
            var typeSpeed = 60;
            var deleteSpeed = 30;
            var pauseEnd = 2000;
            var pauseStart = 500;

            function type() {
                var current = titles[titleIndex];

                if (!isDeleting) {
                    el.textContent = current.substring(0, charIndex + 1);
                    charIndex++;

                    if (charIndex === current.length) {
                        isDeleting = true;
                        setTimeout(type, pauseEnd);
                        return;
                    }
                    setTimeout(type, typeSpeed);
                } else {
                    el.textContent = current.substring(0, charIndex - 1);
                    charIndex--;

                    if (charIndex === 0) {
                        isDeleting = false;
                        titleIndex = (titleIndex + 1) % titles.length;
                        setTimeout(type, pauseStart);
                        return;
                    }
                    setTimeout(type, deleteSpeed);
                }
            }

            // The complete first title is server-rendered for a stable, immediate LCP.
            setTimeout(type, pauseEnd);
        })();

        /* ============================================
           MOBILE MENU
           ============================================ */
        (function () {
            var toggle = document.getElementById('menuToggle');
            var navLinks = document.getElementById('navLinks');
            if (!toggle || !navLinks) return;

            function setAria(open) {
                toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
                toggle.setAttribute('aria-label', open ? toggle.dataset.menuClose : toggle.dataset.menuOpen);
            }

            function closeMenu() {
                toggle.classList.remove('active');
                navLinks.classList.remove('active');
                document.body.classList.remove('menu-open');
                setAria(false);
            }

            toggle.addEventListener('click', function () {
                var isActive = navLinks.classList.toggle('active');
                toggle.classList.toggle('active', isActive);
                document.body.classList.toggle('menu-open', isActive);
                setAria(isActive);
            });

            navLinks.querySelectorAll('.nav-link').forEach(function (link) {
                link.addEventListener('click', closeMenu);
            });

            document.addEventListener('click', function (e) {
                if (navLinks.classList.contains('active') &&
                    !toggle.contains(e.target) &&
                    !navLinks.contains(e.target)) {
                    closeMenu();
                }
            });
        })();

        /* ============================================
           SMOOTH SCROLL FOR NAV LINKS
           ============================================ */
        document.querySelectorAll('.nav-link').forEach(function (link) {
            link.addEventListener('click', function (e) {
                var href = this.getAttribute('href');
                if (href && href.startsWith('#')) {
                    e.preventDefault();
                    var target = document.querySelector(href);
                    if (target) {
                        var header = document.querySelector('.header');
                        var offset = header ? header.offsetHeight : 72;
                        window.scrollTo({
                            top: Math.max(0, target.offsetTop - offset),
                            behavior: 'smooth'
                        });
                    }
                }
            });
        });

        /* ============================================
           HEADER HIDE/SHOW ON SCROLL
           ============================================ */
        (function () {
            var header = document.getElementById('siteHeader');
            if (!header) return;

            var lastScrollY = 0;
            var ticking = false;

            function onScroll() {
                var scrollY = window.pageYOffset || document.documentElement.scrollTop;
                header.classList.toggle('header--hidden', scrollY > lastScrollY && scrollY > 100);
                lastScrollY = scrollY <= 0 ? 0 : scrollY;
                ticking = false;
            }

            window.addEventListener('scroll', function () {
                if (!ticking) {
                    requestAnimationFrame(onScroll);
                    ticking = true;
                }
            }, { passive: true });
        })();

        /* ============================================
           SCROLL SPY — Active nav link
           ============================================ */
        (function () {
            var sections = document.querySelectorAll('section[id]');
            var navItems = document.querySelectorAll('.nav-link[data-section]');
            if (!sections.length || !navItems.length) return;

            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var id = entry.target.getAttribute('id');
                        navItems.forEach(function (item) {
                            item.classList.toggle('active', item.dataset.section === id);
                        });
                    }
                });
            }, {
                rootMargin: '-30% 0px -70% 0px',
                threshold: 0
            });

            sections.forEach(function (section) {
                observer.observe(section);
            });
        })();

        /* ============================================
           SCROLL TO TOP BUTTON
           ============================================ */
        (function () {
            var btn = document.getElementById('scrollToTop');
            if (!btn) return;

            function updateButton() {
                btn.classList.toggle('visible', window.pageYOffset > 400);
            }

            window.addEventListener('scroll', updateButton, { passive: true });
            updateButton();

            btn.addEventListener('click', function () {
                var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
            });
        })();

        /* ============================================
           SCROLL-TRIGGERED REVEAL ANIMATIONS
           ============================================ */
        (function () {
            var reveals = document.querySelectorAll('.reveal-up, .reveal-left, .reveal-right');
            if (!reveals.length) return;

            if ('IntersectionObserver' in window) {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('visible');
                            observer.unobserve(entry.target);
                        }
                    });
                }, {
                    rootMargin: '0px 0px -40px 0px',
                    threshold: 0.15
                });

                reveals.forEach(function (el) { observer.observe(el); });
            } else {
                reveals.forEach(function (el) { el.classList.add('visible'); });
            }
        })();

        /* ============================================
           ANIMATED COUNTERS
           ============================================ */
        (function () {
            var counters = document.querySelectorAll('.stat-card__number[data-target]');
            if (!counters.length) return;

            function animateCounter(el) {
                var target = parseInt(el.dataset.target, 10);
                if (isNaN(target)) return;

                el.textContent = '0';
                var duration = 2000;
                var startTime = null;

                function step(timestamp) {
                    if (!startTime) startTime = timestamp;
                    var progress = Math.min((timestamp - startTime) / duration, 1);
                    var eased = 1 - (1 - progress) * (1 - progress);
                    el.textContent = Math.floor(eased * target);

                    if (progress < 1) {
                        requestAnimationFrame(step);
                    } else {
                        el.textContent = target;
                    }
                }

                requestAnimationFrame(step);
            }

            if ('IntersectionObserver' in window) {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            animateCounter(entry.target);
                            observer.unobserve(entry.target);
                        }
                    });
                }, { threshold: 0.5 });

                counters.forEach(function (el) { observer.observe(el); });
            } else {
                counters.forEach(animateCounter);
            }
        })();

        /* ============================================
           reCAPTCHA LAZY LOAD
           ============================================ */
        (function () {
            var loaded = false;
            function loadRecaptcha() {
                if (loaded) return;
                loaded = true;
                var s = document.createElement('script');
                s.src = 'https://www.google.com/recaptcha/api.js';
                s.async = true;
                s.defer = true;
                document.head.appendChild(s);
            }

            var contact = document.getElementById('contact');
            if (contact && 'IntersectionObserver' in window) {
                var io = new IntersectionObserver(function (entries) {
                    if (entries[0].isIntersecting) {
                        loadRecaptcha();
                        io.disconnect();
                    }
                }, { rootMargin: '100px', threshold: 0 });
                io.observe(contact);
            } else if (contact) {
                contact.addEventListener('focusin', loadRecaptcha, { once: true });
            }

            window.__loadRecaptchaNow = loadRecaptcha;
        })();

        /* ============================================
           CONTACT FORM HANDLER
           ============================================ */
        (function () {
            var form = document.getElementById('contactForm');
            if (!form) return;

            var status = document.getElementById('formStatus');
            var csrf = document.getElementById('csrf_token');
            var btn = document.getElementById('submitBtn');
            var btnText = btn && btn.querySelector('.btn-text');
            var btnSpinner = btn && btn.querySelector('.btn-spinner');
            var btnSuccess = btn && btn.querySelector('.btn-success');
            var btnError = btn && btn.querySelector('.btn-error');

            function setState(s) {
                if (!btn) return;
                btn.className = 'btn btn--primary btn--submit';
                if (btnText) btnText.hidden = false;
                if (btnSpinner) btnSpinner.hidden = true;
                if (btnSuccess) btnSuccess.hidden = true;
                if (btnError) btnError.hidden = true;

                if (s === 'loading') {
                    btn.classList.add('loading');
                    btn.disabled = true;
                    if (btnText) btnText.hidden = true;
                    if (btnSpinner) btnSpinner.hidden = false;
                } else if (s === 'success') {
                    btn.classList.add('success');
                    if (btnText) btnText.hidden = true;
                    if (btnSuccess) btnSuccess.hidden = false;
                    setTimeout(function () { setState(''); }, 2000);
                } else if (s === 'error') {
                    btn.classList.add('error');
                    if (btnText) btnText.hidden = true;
                    if (btnError) btnError.hidden = false;
                    setTimeout(function () { setState(''); }, 2000);
                } else {
                    btn.disabled = false;
                }
            }

            function getToken() {
                fetch('send.php?action=get_csrf_token')
                    .then(function (r) { return r.json(); })
                    .then(function (d) { if (d.csrf_token && csrf) csrf.value = d.csrf_token; })
                    .catch(function () {});
            }

            getToken();

            form.addEventListener('submit', function (e) {
                e.preventDefault();

                if (!window.grecaptcha || !grecaptcha.getResponse()) {
                    if (window.__loadRecaptchaNow && !window.grecaptcha) window.__loadRecaptchaNow();
                    if (status) {
                        status.textContent = (window.SITE_CONTACT && window.SITE_CONTACT.recaptchaError) || 'Please complete the reCAPTCHA.';
                        status.className = 'form-status form-status--error';
                    }
                    return;
                }

                setState('loading');
                if (status) { status.textContent = ''; status.className = 'form-status'; }

                fetch(form.action, {
                    method: 'POST',
                    body: new FormData(form),
                    headers: {
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                .then(function (r) {
                    return r.json().then(function (d) { return { ok: r.ok, data: d }; });
                })
                .then(function (o) {
                    if (o.ok && o.data && o.data.status === 'success') {
                        setState('success');
                        if (status) {
                            status.textContent = (window.SITE_CONTACT && window.SITE_CONTACT.successMessage) || 'Message sent successfully!';
                            status.className = 'form-status form-status--success';
                        }
                        form.reset();
                        if (window.grecaptcha) grecaptcha.reset();
                        getToken();
                    } else {
                        setState('error');
                        if (status) {
                            status.textContent = (o.data && o.data.message) ? o.data.message : ((window.SITE_CONTACT && window.SITE_CONTACT.errorMessage) || 'Error sending message.');
                            status.className = 'form-status form-status--error';
                        }
                        getToken();
                    }
                })
                .catch(function () {
                    setState('error');
                    if (status) {
                        status.textContent = (window.SITE_CONTACT && window.SITE_CONTACT.connectionError) || 'Connection error. Please try again.';
                        status.className = 'form-status form-status--error';
                    }
                });
            });
        })();

        /* ============================================
           FOOTER YEAR
           ============================================ */
        (function () {
            var el = document.getElementById('footerYear');
            if (el) el.textContent = new Date().getFullYear();
        })();

    }); // end DOMContentLoaded

})();
